import { createSlice } from '@reduxjs/toolkit';

const initialState={
    calendar:null
}
export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {

    
      
      setCalendar: (state, action) => {
        state.calendar = action.payload;
        
      },
      setLogoutCalendar: (state,action)=>{
      state.calendar=null
    }
  },
});

export const {  setCalendar,setLogoutCalendar } = calendarSlice.actions;

export default calendarSlice.reducer;
